<div class="guest-hours-sched">
	@if (meetingtype) {
		<div class="dates-row">
			<button
				class="cal-btn cal-icon"
				(click)="periodGo(-1)"
				icon="rightArrow"
			></button>
			<div class="dates-title">
				{{ startDate | dateFormat }} - {{ endDate | dateFormat }}
			</div>
			<button
				class="cal-btn cal-icon"
				(click)="periodGo(1)"
				icon="leftArrow"
			></button>
		</div>
		<div class="hours-space d-grid gap-3">
			<!--  <div class="col-12 col-md-4 no-mob">-->
			<!--    <app-date-picker noInput (changeEvent)="chDate($event)"></app-date-picker>-->
			<!--  </div>-->

			@for (availableDate of availableDates; track availableDate) {
				<div>
					@if (newWeeksDates[availableDate]) {
						<div class="spacer"></div>
					}
					<div class="date-row">
						<div class="weekday-and-date">
							{{ datesToDays[availableDate] | langVal }}
						</div>
						<div class="weekday-and-date">
							{{ availableDate | dateFormat }}
						</div>
						<div class="d-flex gap-1">
							@for (
								block of availableTimeBlocksDates[availableDate];
								track block
							) {
								<button
									class="btn btn-primary"
									(click)="openMeetingModal(availableDate, block)"
								>
									{{ block }}
								</button>
							}
						</div>
					</div>
				</div>
			}
		</div>
	}
	@if (!meetingtype) {
		<div class="row scheduler-content">
			<div
				class="col-12"
				style="padding-bottom: 16px"
			>
				@if (availableMeetingtypesFirst?.length) {
					@if (availableMeetingtypesReturn?.length) {
						<h4>{{ "for_first_time_meeting" | langVal }}</h4>
					} @else {
						<h4>{{ "for_meeting" | langVal }}</h4>
					}

					<div class="d-flex">
						@for (
							availableMeetingtype of availableMeetingtypesFirst;
							track availableMeetingtype
						) {
							<button
								[title]="
									('select_meeting_type' | langVal) +
									' ' +
									(availableMeetingtype.name | langVal)
								"
								(click)="chooseMeetingtypeFirst(availableMeetingtype)"
								class="btn btn-default"
								[class.active]="meetingtype?.id == availableMeetingtype.id"
								[class.btn-primary]="meetingtype?.id == availableMeetingtype.id"
							>
								{{ availableMeetingtype.name | langVal }} ({{
									availableMeetingtype.length
								}}
								{{ "minutes" | langVal }})
							</button>
						}
					</div>
				}
				<!--  @else {  	<p>{{ "no_meetingtypes_available" | langVal }}</p>}-->
			</div>

			<div class="col-12">
				@if (availableMeetingtypesReturn?.length) {
					@if (availableMeetingtypesFirst?.length) {
						<h4>{{ "for_return_meeting" | langVal }}</h4>
					} @else {
						<h4>{{ "for_meeting" | langVal }}</h4>
					}
					<div class="d-flex">
						@for (
							availableMeetingtype of availableMeetingtypesReturn;
							track availableMeetingtype
						) {
							<button
								[title]="
									('select_meeting_type' | langVal) +
									' ' +
									(availableMeetingtype.name | langVal)
								"
								(click)="chooseMeetingtypeReturn(availableMeetingtype)"
								class="btn btn-default"
								[class.active]="meetingtype?.id == availableMeetingtype.id"
								[class.btn-primary]="meetingtype?.id == availableMeetingtype.id"
							>
								{{ availableMeetingtype.name | langVal }} ({{
									availableMeetingtype.length
								}}
								{{ "minutes" | langVal }})
							</button>
						}
					</div>
				}
				<!--  @else {  	<p>{{ "no_meetingtypes_available" | langVal }}</p>}-->
			</div>
		</div>
	}
	@if (eventsService.isMobile && dataObj?.meeting_request_with_calendar) {
		<div>
			<button
				class="btn btn-icon btn-back"
				(click)="backEv.emit()"
				icon="back"
			></button>
		</div>
	}
</div>
